export function formatFileSize(bytes?: number | null): string {
  if (bytes == null) return "";

  const sizeSuffixes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const byteConversion = 1024;

  if (bytes === 0) {
    return `0 ${sizeSuffixes[0]}`;
  }

  // Find the "place" (index into suffixes) using logarithm
  const place = Math.floor(Math.log(bytes) / Math.log(byteConversion));

  // Scale the number into that unit, round to 2 decimals
  const size = (bytes / Math.pow(byteConversion, place)).toFixed(2);

  return `${size} ${sizeSuffixes[place]}`;
}
